import React, { useEffect, useMemo } from "react";
import { ControlBarContext } from "./index";
import { useUserActivity } from "../UserActivity";
import { usePointerState } from "../../hooks/usePointerState";
import { useVideoPlayerRefs } from "../VideoPlayerRefs";
import { useRoot } from "../Root";
import { Controls } from "../..";

export interface ControlBarProps {
  children?: React.ReactNode;
  controlBarActiveCallback?: (active: boolean) => void;
}

export const ControlBarProvider = ({
  children,
  controlBarActiveCallback,
}: ControlBarProps) => {
  const { controls } = useRoot();
  const { controlBar } = useVideoPlayerRefs();
  const isUserActive = useUserActivity();
  const { isInside, isDown } = usePointerState(controlBar);

  const isActive =
    (isUserActive || isInside || isDown) &&
    (controls === Controls.fullControlBar ||
      controls === Controls.partialControlBar);

  useEffect(() => {
    if (controlBarActiveCallback !== undefined) {
      controlBarActiveCallback(isActive);
    }
  }, [controlBarActiveCallback, isActive]);

  const value = useMemo(
    () => ({
      isActive,
    }),
    [isActive]
  );

  return (
    <ControlBarContext.Provider value={value}>
      {children}
    </ControlBarContext.Provider>
  );
};
